import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const DirectorUpdateModalUI = ({ context, loan, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  name,
  address, onAddressChange, addressError, setAddressError,
  sharePledgedNumber, onSharePledgedNumberChange, sharePledgedNumberError, setSharePledgedNumberError,
  sharePledgedPercent, onSharePledgedPercentChange, sharePledgedPercentError, setSharePledgedPercentError,
  nduPercent, onNduPercentChange, nduPercentError, setNduPercentError,
  pledgor, onPledgorChange, pledgorError, setPledgorError,
  guarantor, onGuarantorChange, guarantorError, setGuarantorError, booleanList,
  cibilScore, onCibilScoreChange, cibilScoreError, setCibilScoreError,
  phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
  email, onEmailChange, emailError, setEmailError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update promoter'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <div className='g_flex_h g_flex_top'>
      <div className='cols g_m_right_100'>
        <b>{name}</b>
        <InputTextSF type='text' name='email' label='Email'
          required={true} maxLength={100}
          value={email} onChange={onEmailChange}
          error={emailError} setError={setEmailError}
        />
        <InputTextSF type='text' name='phoneNumber' label='Phone No.'
          maxLength={16}
          value={phoneNumber} onChange={onPhoneNumberChange}
          error={phoneNumberError} setError={setPhoneNumberError}
        />
        <InputTextSF type='text' name='address' label='Address'
          required={true} maxLength={100}
          value={address} onChange={onAddressChange}
          error={addressError} setError={setAddressError}
        />
        {/* <InputSelectUI name='pledgor' value={pledgor}
          label='Pledgor' optionList={booleanList}
          onChange={onPledgorChange} error={pledgorError}
        /> */}
        <InputTextSF type='text' name='sharePledgedNumber' label='Number of equity shares'
          value={sharePledgedNumber} onChange={onSharePledgedNumberChange}
          error={sharePledgedNumberError} setError={setSharePledgedNumberError}
        />
      </div>
      <div className='cols g_m_left_100'>
        {
          loan.appFlavor !== 'small_loan' &&
          <InputTextSF type='text' name='sharePledgedPercent' label='Percentage of shares pledged'
            maxLength={8}
            value={sharePledgedPercent} onChange={onSharePledgedPercentChange}
            error={sharePledgedPercentError} setError={setSharePledgedPercentError}
          />
        }
        <InputTextSF type='text' name='nduPercent' label='NDU %'
          maxLength={8}
          value={nduPercent} onChange={onNduPercentChange}
          error={nduPercentError} setError={setNduPercentError}
        />
        {
          loan.appFlavor !== 'small_loan' &&
          <InputSelectUI name='guarantor' value={guarantor}
            label='Guarantor' optionList={booleanList}
            onChange={onGuarantorChange} error={guarantorError}
          />
        }
        <InputTextSF type='text' name='cibilScore' label='CIBIL score (300-900)'
          maxLength={3}
          value={cibilScore} onChange={onCibilScoreChange}
          error={cibilScoreError} setError={setCibilScoreError}
        />
      </div>
    </div>
  </ModalFormUI>

export default DirectorUpdateModalUI
